module.exports = __webpack_public_path__ + "static/media/responsibility-body-bg-widescreen.03e4dc1c.png";